import { render, staticRenderFns } from "./repairer-view.vue?vue&type=template&id=c31af840"
import script from "./repairer-view.vue?vue&type=script&lang=js"
export * from "./repairer-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports